export default __webpack_public_path__ + "static/client8-5fa1ce6be9ef2769c45a336ff188106d.png";